import {IAction, IApInvokerArguments} from '../../interfaces';

enum LabResultAttachmentActions {
  LAB_RESULT_ATTACHMENT_LOAD = '[lab-result-attachment] load',
  LAB_RESULT_ATTACHMENT_LOAD_SUCCESS = '[lab-result-attachment] load success',
  LAB_RESULT_ATTACHMENT_LOAD_FAIL = '[lab-result-attachment] load fail',
  LAB_RESULT_ATTACHMENT_DELETE = '[lab-result-attachment] delete',
  LAB_RESULT_ATTACHMENT_UPLOAD = '[lab-result-attachment] upload',
  LAB_RESULT_ATTACHMENT_UPLOAD_SUCCESS = '[lab-result-attachment] upload success',
  LAB_RESULT_ATTACHMENT_UPLOAD_FAIL = '[lab-result-attachment] upload fail',
  LAB_RESULT_ATTACHMENT_DOWNLOAD = '[lab-result-attachment] download',
  LAB_RESULT_ATTACHMENT_DOWNLOAD_SUCCESS = '[lab-result-attachment] download success',
  LAB_RESULT_ATTACHMENT_DOWNLOAD_FAIL = '[lab-result-attachment] download fail'
}

export class LabResultAttachmentLoad implements IAction {
  readonly type = LabResultAttachmentActions.LAB_RESULT_ATTACHMENT_LOAD;

  constructor(public payload: IApInvokerArguments[]) {
  }
}

export class LabResultAttachmentLoadSuccess implements IAction {
  readonly type = LabResultAttachmentActions.LAB_RESULT_ATTACHMENT_LOAD_SUCCESS;

  constructor(public payload: IApInvokerArguments[]) {
  }
}

export class LabResultAttachmentLoadFail implements IAction {
  readonly type = LabResultAttachmentActions.LAB_RESULT_ATTACHMENT_LOAD_FAIL;

  constructor(public payload: IApInvokerArguments[]) {
  }
}

export class LabResultAttachmentDelete implements IAction {
  readonly type = LabResultAttachmentActions.LAB_RESULT_ATTACHMENT_DELETE;

  constructor(public payload: IApInvokerArguments[]) {
  }
}

export class LabResultAttachmentUpload implements IAction {
  readonly type = LabResultAttachmentActions.LAB_RESULT_ATTACHMENT_UPLOAD;

  constructor(public payload: IApInvokerArguments[]) {
  }
}

export class LabResultAttachmentUploadSuccess implements IAction {
  readonly type = LabResultAttachmentActions.LAB_RESULT_ATTACHMENT_UPLOAD_SUCCESS;

  constructor(public payload: IApInvokerArguments[]) {
  }
}

export class LabResultAttachmentUploadFail implements IAction {
  readonly type = LabResultAttachmentActions.LAB_RESULT_ATTACHMENT_UPLOAD_FAIL;

  constructor(public payload: IApInvokerArguments[]) {
  }
}

export class LabResultAttachmentDownload implements IAction {
  readonly type = LabResultAttachmentActions.LAB_RESULT_ATTACHMENT_DOWNLOAD;

  constructor(public payload: IApInvokerArguments[]) {
  }
}

export class LabResultAttachmentDownloadSuccess implements IAction {
  readonly type = LabResultAttachmentActions.LAB_RESULT_ATTACHMENT_DOWNLOAD_SUCCESS;

  constructor(public payload: IApInvokerArguments[]) {
  }
}

export class LabResultAttachmentDownloadFail implements IAction {
  readonly type = LabResultAttachmentActions.LAB_RESULT_ATTACHMENT_DOWNLOAD_FAIL;

  constructor(public payload: IApInvokerArguments[]) {
  }
}
